import React, {Component} from "react";
import {connect} from "react-redux";

class NumericKeyboardInput extends Component {
    constructor(props) {
        super(props);

        this.state = {
            keyboardActive: false
        };
    }

    onFocus = (event) => {
        if (this.props.onFocus !== undefined) {
            this.props.onFocus(event);
        }

        if (this.props.virtualKeyboardEnabled) {
            this.setState({
                keyboardActive: true
            });
        }
    };

    onBlur = (event) => {
        if (this.props.onBlur !== undefined) {
            this.props.onBlur(event);
        }

        this.setState({
            keyboardActive: false
        });
    };

    handleKeyClick = (event) => {
        let value = event.target.dataset.value;

        if (value === "bksp") {
            event.preventDefault();

            if (this.props.value.length > 1) {
                this.props.setInputState(this.props.value.substring(0, this.props.value.length - 1));
            } else {
                this.props.setInputState("");
            }
        }

        if (value !== "bksp" && value !== "ok") {
            event.preventDefault();

            if (value === ".") {
                this.props.setInputState(this.props.value + value);
            } else {
                let valueText = this.props.value + value;
                if (
                    this.props.maxValue === undefined ||
                    this.props.maxValue === null ||
                    Number(valueText) < this.props.maxValue
                ) {
                    if (isNaN(valueText)) {
                        this.props.setInputState(valueText);
                    } else if (valueText.includes(".")) {
                        this.props.setInputState(valueText);
                    } else {
                        this.props.setInputState(String(Number(valueText)));
                    }
                }
            }
        }
    };

    getNumberKeys = () => {
        return (
            <React.Fragment>
                <div className="key" onMouseDown={this.handleKeyClick} data-value="1">
                    1
                </div>
                <div className="key" onMouseDown={this.handleKeyClick} data-value="2">
                    2
                </div>
                <div className="key" onMouseDown={this.handleKeyClick} data-value="3">
                    3
                </div>
                <div className="key" onMouseDown={this.handleKeyClick} data-value="4">
                    4
                </div>
                <div className="key" onMouseDown={this.handleKeyClick} data-value="5">
                    5
                </div>
                <div className="key" onMouseDown={this.handleKeyClick} data-value="6">
                    6
                </div>
                <div className="key" onMouseDown={this.handleKeyClick} data-value="7">
                    7
                </div>
                <div className="key" onMouseDown={this.handleKeyClick} data-value="8">
                    8
                </div>
                <div className="key" onMouseDown={this.handleKeyClick} data-value="9">
                    9
                </div>
            </React.Fragment>
        );
    };

    getNumericKeyboard = () => {
        if (!this.state.keyboardActive) {
            return null;
        }

        if (this.props.extended) {
            return (
                <div className="num-keys-extended">
                    {this.getNumberKeys()}
                    <div className="key" onMouseDown={this.handleKeyClick} data-value="bksp">
                        &#60;
                    </div>
                    <div className="key" onMouseDown={this.handleKeyClick} data-value="0">
                        0
                    </div>
                    <div className="key" onMouseDown={this.handleKeyClick} data-value=".">
                        .
                    </div>
                    <div className="key-extended" onMouseDown={this.handleKeyClick} data-value="ok">
                        &#x2713;
                    </div>
                </div>
            );
        }

        return (
            <div className="num-keys">
                {this.getNumberKeys()}
                <div className="key" onMouseDown={this.handleKeyClick} data-value="bksp">
                    &#60;
                </div>
                <div className="key" onMouseDown={this.handleKeyClick} data-value="0">
                    0
                </div>
                <div className="key" onMouseDown={this.handleKeyClick} data-value="ok">
                    &#x2713;
                </div>
            </div>
        );
    };

    getKeyboardElementProps = () => {
        let props = {...this.props};

        delete props["extended"];
        delete props["setInputState"];
        delete props["dispatch"];
        delete props["redlikeLightSoftware"];
        delete props["gammaSoftware"];
        delete props["virtualKeyboardEnabled"];
        delete props["maxValue"];

        return {
            ...props,
            onFocus: this.onFocus,
            onBlur: this.onBlur
        };
    };

    getElementProps = () => {
        let props = {...this.props};

        delete props["extended"];
        delete props["setInputState"];
        delete props["dispatch"];
        delete props["redlikeLightSoftware"];
        delete props["gammaSoftware"];
        delete props["virtualKeyboardEnabled"];
        delete props["maxValue"];

        return props;
    };

    render() {
        if (this.props.redlikeLightSoftware || this.props.gammaSoftware) {
            if (this.props.virtualKeyboardEnabled) {
                return (
                    <React.Fragment>
                        {React.createElement("input", this.getKeyboardElementProps())}
                        {this.getNumericKeyboard()}
                    </React.Fragment>
                );
            }
        }

        return React.createElement("input", this.getElementProps());
    }
}

export default NumericKeyboardInput = connect((store) => {
    return {
        redlikeLightSoftware: store.module.redlikeLightSoftware,
        gammaSoftware: store.module.gammaSoftware,
        virtualKeyboardEnabled: store.settings.virtualKeyboardEnabled
    };
})(NumericKeyboardInput);
